module.exports = __webpack_public_path__ + "media/images/stripe/light-on-dark@2x-7fdf66a3f54d749f20c0f1274eba3f23.png";